var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomersActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 6.49935C12.3333 7.78801 11.2887 8.83268 10 8.83268C8.71134 8.83268 7.66667 7.78801 7.66667 6.49935C7.66667 5.21068 8.71134 4.16602 10 4.16602C11.2887 4.16602 12.3333 5.21068 12.3333 6.49935Z",
    fill: "#525252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2222 8.0549C16.2222 8.91401 15.5258 9.61046 14.6667 9.61046C13.8076 9.61046 13.1111 8.91401 13.1111 8.0549C13.1111 7.1958 13.8076 6.49935 14.6667 6.49935C15.5258 6.49935 16.2222 7.1958 16.2222 8.0549Z",
    fill: "#525252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1111 13.4993C13.1111 11.7811 11.7182 10.3882 10 10.3882C8.28178 10.3882 6.88889 11.7811 6.88889 13.4993V15.8327H13.1111V13.4993Z",
    fill: "#525252"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88889 8.0549C6.88889 8.91401 6.19244 9.61046 5.33333 9.61046C4.47422 9.61046 3.77778 8.91401 3.77778 8.0549C3.77778 7.1958 4.47422 6.49935 5.33333 6.49935C6.19244 6.49935 6.88889 7.1958 6.88889 8.0549Z",
    fill: "#525252"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 15.8327V13.4993C14.6667 12.6795 14.4552 11.909 14.0839 11.2394C14.2702 11.1915 14.4654 11.166 14.6667 11.166C15.9553 11.166 17 12.2107 17 13.4993V15.8327H14.6667Z",
    fill: "#525252"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91609 11.2394C5.54477 11.909 5.33333 12.6795 5.33333 13.4993V15.8327H3V13.4993C3 12.2107 4.04467 11.166 5.33333 11.166C5.53455 11.166 5.72982 11.1915 5.91609 11.2394Z",
    fill: "#525252"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersActive);
export default __webpack_public_path__ + "static/media/customers-active.9d464a1a6d1f12e4848cd8e68ce965ad.svg";
export { ForwardRef as ReactComponent };